import {Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {AssetTranscode, TranscodeItem} from "./asset-transcode";

@Component({
  standalone: false,
  selector: 'asset-transcode',
  template: `
    <div *ngIf="assetTranscode.size > 0" class="caption text-center">
      <div class="assetTranscodeDropdown dropdown">
        <button
          type="button"
          class="assetTranscodeToggle"
          [attr.aria-expanded]="popupOpened"
          (click)="togglePopup()">
          <span *ngIf="transcodeProgress">Transcoding... <span class="fa fa-cog fa-spin"></span><span class="fa fa-fw fa-info-circle"></span></span>
          <span *ngIf="transcodeSuccess">Formats <span class="fa fa-fw fa-info-circle"></span></span>
          <span *ngIf="transcodeErrors" class="text-danger">Formats <span class="fa fa-fw fa-info-circle"></span></span>
        </button>
        <div *ngIf="popupOpened" class="assetTranscodeMenu dropdown-menu dropdownWithArrow show">
          <div class="row" *ngFor="let transcodeItem of assetTranscode | keyvalue">
            <label class="col-md-4 control-label">{{ transcodeItem.key }}</label>
            <div class="col-md-8">
              <div class="form-control-static">
                <span *ngIf="transcodeItem.value.status === 'TRANSCODING'" class="fa fa-cog fa-spin"></span>
                <span *ngIf="transcodeItem.value.status === 'QUEUED'" class="fa fa-cog fa-spin"></span>
                <span *ngIf="transcodeItem.value.width && transcodeItem.value.height">{{ transcodeItem.value.width }}x{{ transcodeItem.value.height }}, </span>
                <span *ngIf="transcodeItem.value.bps && transcodeItem.value.bps < 1000000">{{ transcodeItem.value.bps / 1000 }} kbps, </span>
                <span *ngIf="transcodeItem.value.bps && transcodeItem.value.bps >= 1000000">{{ transcodeItem.value.bps / 1000000 }} Mbps, </span>
                <span>{{ transcodeItem.value.mimeType | mimeTypeKey | translate }}</span>
                <div *ngIf="transcodeItem.value.errorMessage">
                  <div class="label label-danger">Error Transcoding</div>
                </div>
                &nbsp;<a *ngIf="transcodeItem.value.cdnId" [href]="transcodeItem.value.cdnId" target="_blank"><span class="fa fa-external-link"></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class AssetTranscodeComponent implements OnInit, OnChanges {
  @Input() assetTranscodeObject: any;
  assetTranscode: AssetTranscode = new Map();
  popupOpened = false;
  transcodeProgress = false;
  transcodeSuccess = false;
  transcodeErrors = false;

  constructor(private eRef: ElementRef) {
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent): void {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.hidePopup();
    }
  }

  ngOnInit(): void {
    this.refreshTranscode();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.assetTranscodeObject) {
      this.refreshTranscode();
    }
  }

  private refreshTranscode(): void {
    const entries = this.assetTranscodeObject ? Object.entries(this.assetTranscodeObject) : [];
    this.assetTranscode = new Map<string, TranscodeItem>(entries as Array<[string, TranscodeItem]>);
    const values = Array.from(this.assetTranscode.values());
    this.transcodeProgress = values.some(item => item.status === 'QUEUED' || item.status === 'TRANSCODING');
    this.transcodeSuccess = values.some(item => item.status === 'SUCCESS');
    this.transcodeErrors = values.some(item => item.status === 'ERROR');
  }

  togglePopup(): void {
    this.popupOpened = !this.popupOpened;
  }

  hidePopup(): void {
    this.popupOpened = false;
  }
}
